<script>
import Vue from 'vue'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import { required, minLength, maxLength } from 'vuelidate/lib/validators'

/**
 Editar Categoria Component
 */
export default {
  components: { Layout, PageHeader,Multiselect },
  page: {
    title: 'SubCategorias',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      title: 'SubCategoria',
       form: {
        subCategoriaId:'',
        categoriaId: '',
        descripcion: '',
         categoria:{
          categoriaId:'',
          descripcion:''
        }        
      },
      isLoadingCombo: false,                  
      listadoCategorias: [],
      requestComboCategorias: {
        perPage: 1000,
        cuerrentPage: 0,
        filter: ""
        },
      items: [
        {
          text: 'Sistema Tributario',
          href: '/',
        },
        {
          text: 'SubCategorias',
          href: '/subcategorias/',
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
      submitted: false,
      isBusy: false,
    }
  },
  validations: {
    form: {
      descripcion: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(200),
      },
      subCategoriaId: {
        required,      
      },
      categoria: {
        required,      
      },
    },
  },
  computed: {},
  mounted() {
    this.loadCategorias();
    this.loadSubCategoria(this.$route.params.id)
  },
  methods: {
    loadSubCategoria(id){
       axios
            .get(appConfig.recursosApi.subcategorias + "/" + id )
            .then((response) => {
                this.form = response.data                
            })
             .catch(()=>  {
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                this.$router.push('/500') ;
            });

    },    
    _validations() {
      return new Promise((resolve) => {
        if (this.$v.$error || !this.$v.$pending) {
          return resolve()
        }
        let poll = setInterval(() => {
          if (!this.$v.$pending) {
            clearInterval(poll)
            resolve()
          }
        }, 200)
      })
    },

    async isValid() {
      this.$v.$reset()
      this.$v.$touch()
      await this._validations()
      return Promise.resolve(!this.$v.$error)
    },

    async handleSubmit(e) {
      this.submitted = true
      const valid = await this.isValid()
      this.isBusy = false

      if (valid) {
        this.isBusy = true
        this.form.categoriaId = this.form.categoria.categoriaId;
        axios
          .put(appConfig.recursosApi.subcategorias, this.form)
          .then((response) => {
            this.isBusy = false
            this.$router.push('/subcategorias/index/true')
          })
          .catch(() => {
            this.isBusy = false
            Vue.swal({
              type: 'error',
              title: 'Oops...',
              text: 'Ocurrio un error al intentar guardar los datos.',
              confirmButtonClass: 'btn btn-confirm mt-2',
            })
          })
      }
    },
    loadCategorias(query = "") {
            this.isLoadingCombo = true;
            this.requestComboCategorias.filter = query;
            axios
                .get(appConfig.recursosApi.categorias, {
                    params: this.requestComboCategorias
                })
                .then((response) => {
                    this.listadoCategorias = response.data.result;
                    this.isLoadingCombo = false;
                    return this.data
                })
                .catch(() => {
                    this.listadoCategorias = [];
                    this.isLoadingCombo = false;
                    // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                     this.$router.push('/500');
                });
    },
  },
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title m-t-0">Nueva SubCategoria</h4>
          <p class="text-muted font-14 m-b-20"
            >Ingresa la información de la SubCategoria.</p
          >

          <form @submit.prevent="handleSubmit">
            <!-- Datos SubCategoria -->
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="name">
                  No. Cuenta
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="subCategoriaId"
                  v-model="form.subCategoriaId"
                  name="subcategoriaId"
                  class="form-control"
                  disabled
                  :class="{
                    'is-invalid': submitted && $v.form.subCategoriaId.$error,
                  }"
                  type="text"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.subCategoriaId.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.subCategoriaId.required"
                    >Debe indicar el número de cuenta.</span
                  >
                  
                </div>
              </div>              
              <div class="form-group col-md-6">
                
              </div>
            </div>
            <div class="form-row">              
              <div class="form-group col-md-12">
                <label>
                  Categoria
                  <span class="text-danger"></span>
                </label>
                <multiselect id="categoria" v-model="form.categoria" label="descripcion" track-by="categoriaId" placeholder="Teclea una categoria" open-direction="bottom" deselect-label=" X " select-label=" + " selected-label=" Seleccionado" :options="listadoCategorias" :multiple="false" :searchable="true" :loading="isLoadingCombo" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="100" :limit="3" :max-height="500" :show-no-results="true" :hide-selected="false" :class="{ 'is-invalid': submitted && $v.form.categoria.$error }" @search-change="loadCategorias">
                                <span slot="noResult">No se encontraron resultados.</span>
                                <span slot="noOptions">No se encontraron organismos.</span>
                 </multiselect>
                <div v-if="submitted && !$v.form.categoria.required" style="display:block;" class="invalid-feedback">Debe seleccionar una categoria.</div>
              </div>
            </div>
            <div class="form-row">              
              <div class="form-group col-md-12">
                <label>
                  Descripción
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.descripcion"
                  type="text"
                  name="descripcion"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.descripcion.$error,
                  }"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.descripcion.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.descripcion.required"
                    >La Descripción es requerida.</span
                  >
                </div>
              </div>
              
            </div>

            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">
                <b-spinner v-show="isBusy" small></b-spinner> Guardar</button
              >
              <router-link
                class="btn btn-secondary m-l-5 ml-1"
                to="/subcategorias/index"
              >
                Cancelar</router-link
              >
            </div>
          </form>
        </div>
        <!-- end card-box -->
      </div>
    </div>
  </Layout>
</template>